const COUNTRY_ISO_CODE_FROM_LOCALE_REGEX = /^[a-z]{2}-([A-Z]{2})$/;

export default function countryIsoCodeFromLocale(locale) {
  const match = COUNTRY_ISO_CODE_FROM_LOCALE_REGEX.exec(locale);
  if (!match) {
    return null;
  }
  return match[1];
}
